import * as React from "react";
import { Select, Spin } from "antd";
const Option = Select.Option;
import { SelectProps } from "antd/lib/select";
import { contactsStore } from "Stores/ContactsStore";
import { I18N_NS } from "Config/i18n";
import { WithTranslation, withTranslation } from "react-i18next";
import { formatUsername } from "utils/formatUsername";

interface UserSelectionProps extends SelectProps<number>, WithTranslation {
  id?: string;
  withDisabledId?: boolean;
  hideHiddenUsers?: boolean;
  hideInactiveUsers?: boolean;
}

export const UserSelection = withTranslation(I18N_NS.ADMIN)(
  class extends React.Component<UserSelectionProps> {
    get options() {
      let options = contactsStore.projectUsers;
      if (this.props.hideHiddenUsers) {
        options = options.filter(({ projectRole }) => projectRole !== "HID");
      }
      if (this.props.hideInactiveUsers) {
        options = options.filter(({ active }) => active);
      }
      return options.map((val) => {
        return (
          <Option value={val.id} key={val.id} disabled={!val.active}>
            {`${formatUsername({ firstName: val.firstName, surname: val.surname })}`}
          </Option>
        );
      });
    }
    render() {
      if (contactsStore.state === "LOADING") {
        return <Spin />;
      } else {
        const { withDisabledId, hideHiddenUsers: _hideHiddenUsers, t, ...rest } = this.props;
        return (
          <Select showSearch={true} {...rest} optionFilterProp="children">
            {withDisabledId && <Option value={-1}>{t("Deactivated")}</Option>}
            {this.options}
          </Select>
        );
      }
    }
  }
);
